import styled from 'styled-components';
import { Modal as CustomModal } from '@getinapp/appetizer';

export const Wrapper = styled.div`
  .ReactModal__Overlay {
    width: 100%;
    height: 100%;
  }
`;

export const Modal = styled(CustomModal)`
  background: white;
`;

export const WrapperButtons = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: flex-end;

  margin-top: 2rem;

  .come-back {
    margin-left: 2rem;
  }
`;
